import React from "react";
import Pin from "../../../assets/pin.png";
import Dart from "../../../assets/dart.png";
import Statistics from "../../../assets/statistics-mac.webp";
import Mookoob from "../../../assets/mookoob-mac.webp";
import lmis from "../../../assets/lmis-mac.webp";
import lizzy from "../../../assets/lizzy-mac.webp";
import Job from "../../../assets/job-mac.webp";
import Space44 from "../../../assets/space44.png";
import Button from "../../Utilities/Button";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import ProjectItem from "./ProjectItem";

gsap.registerPlugin(ScrollTrigger);

const Projects = () => {
    const navigate = useNavigate();
    return (
        <div className="mb-40 layout lg:my-32 xl:my-48 text-white">
            <div className="flex-col items-center lg:items-start mb-32 space-y-4 flex md:hidden">
                <p className=" text-xl text-center lg:text-left">Frontend Developer & UI Designer</p>
                <Button
                    variant="primary"
                    onClick={() => navigate("/contact")}
                    custom="w-1/2 py-2"
                >
                    contact me
                </Button>
                <a
                    href="https://eyobelkirub.dev/resume.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-1/2"
                >
                    <Button variant="outline" custom="w-full py-2">
                        Resume
                    </Button>
                </a>
            </div>
            <div id="projects" className="text-white title-ref">
                <h1 className="relative mb-8 flex items-center font-semibold text-5xl lg:mb-10 xl:text-6xl 2xl:text-7xl">
                    Projects
                </h1>
            </div>

            <div className=" space-y-12 sm:space-y-20 2xl:space-y-40">
                <ProjectItem
                    img={Space44}
                    title="Space44"
                    detail="/project/space44"
                    website="https://space44.com"
                    flip={false}
                    bullets={[
                        "Internal HR ops platform (like Personio) for contractors, clients, and projects",
                        "Built interactive drag-and-drop interfaces and complex data-driven UIs",
                        "Data dashboards with Recharts / Chart.js for live performance tracking",
                        "Form-heavy flows with react-hook-form + Zod across all core modules",
                    ]}
                />
                <ProjectItem
                    img={lizzy}
                    title="Lizzy AI"
                    detail="/project/lizzy"
                    website="https://lizzyai.com"
                    flip={true}
                    bullets={[
                        "Built a chat-based AI interface for legal workflows (Electron + React)",
                        "Designed responsive UI for AI interactions and document workflows",
                        "Improved performance → reduced load times by 35%",
                        "Delivered both desktop (Word plugin) and web versions",
                    ]}
                />
                <ProjectItem
                    img={Mookoob}
                    title="Mookoob"
                    detail="/project/mookoob"
                    website="https://mookoob.com"
                    flip={false}
                    bullets={[
                        "Led UI/UX and frontend for a services marketplace (Figma, Next.js, Tailwind)",
                        "Designed flows so businesses can publish services and reach customers easily",
                        "Applied SEO-oriented patterns so offerings surface in search",
                        "Shipped a responsive product with GraphQL, Apollo, and a cohesive design system",
                    ]}
                />
                <ProjectItem
                    img={lmis}
                    title="E-LMIS"
                    detail="/project/lmis"
                    website="https://lmis.gov.et"
                    flip={true}
                    bullets={[
                        "National labor market platform for Ethiopia (biometrics, jobs, learning, careers)",
                        "Implemented UI from design specs with Next.js, React, Tailwind & GraphQL",
                        "Responsive, data-heavy flows used by thousands as stations scale nationwide",
                        "Frontend integrated with GraphQL/Apollo for real LMIS data and services",
                    ]}
                />
                <ProjectItem
                    img={Statistics}
                    title="Statistics Dashboard"
                    detail="/project/statistics-dashboard"
                    website="https://dashboard.lmis.gov.et/"
                    flip={false}
                    bullets={[
                        "Dashboards for E-LMIS registrations and biometric capture volumes",
                        "Weekly, monthly, and yearly views of station performance plus goal tracking",
                        "Built to monitor rollout as new registration stations go live",
                        "React, Tailwind, GraphQL & Apollo for live operational metrics",
                    ]}
                />
                <ProjectItem
                    img={Job}
                    title="My Career"
                    detail="/project/my-career"
                    flip={true}
                    bullets={[
                        "Job-matching UI for employers and job seekers inside the E-LMIS ecosystem",
                        "Employer profiles with legal docs, job posts, and applicant tracking",
                        "One-click applications using profiles captured at registration",
                        "Aggregates roles from Telegram and other sources (React, Tailwind, GraphQL, Apollo)",
                    ]}
                />
            </div>
        </div>
    );
};

export default Projects;
